import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSButton } from "@web-monorepo/dds";
import { type ReactNode, useState } from "react";
import TeacherTips from "./TeacherTips";
import styles from "./WithTeacherTips.module.css";

function getTips() {
  return [
    t`Give your class some time to think.`,
    t`Ask the class to write down their answers… and no erasing!`,
    t`Encourage your students to be listeners by sharing with their neighbors.`,
    t`Get students moving! They can show their opinion by moving to different sides of the classroom.`,
    t`See if anyone changed their minds!`,
  ];
}

type WithTeacherTipsProps = {
  children: ReactNode;
};

// Wraps a slide with a floating "Tips" button that reveals a full-screen
// TeacherTips overlay. Single boolean state — useState is fine here
// (well under the >2 useState threshold for useClassState).
export default function WithTeacherTips({ children }: WithTeacherTipsProps) {
  const [showingTips, setShowingTips] = useState(false);
  return (
    <div>
      <DDSButton
        data-name="with_teacher_tips:tips"
        variant="primary"
        size="small"
        className={styles.tipsButton}
        onClick={() => setShowingTips(true)}
      >
        <Trans>Tips</Trans>
      </DDSButton>
      <div className={styles.contentWrapper}>{children}</div>
      {showingTips && (
        <div className={styles.overlay}>
          <TeacherTips tips={getTips()} onClose={() => setShowingTips(false)} />
        </div>
      )}
    </div>
  );
}
